export default "__VITE_ASSET__CUulh690__"